var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.174,
    height: 22.65,
    viewBox: "0 0 21.174 22.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#09819a;stroke:#09819a;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.3,1.477H19.721V.369A.369.369,0,0,0,19.351,0H16.767A.369.369,0,0,0,16.4.369V1.477H8.276V.369A.369.369,0,0,0,7.907,0H5.323a.369.369,0,0,0-.369.369V1.477H2.369A.369.369,0,0,0,2,1.846V21.781a.369.369,0,0,0,.369.369H22.3a.369.369,0,0,0,.369-.369V1.846A.369.369,0,0,0,22.3,1.477ZM17.136.738h1.846V2.953H17.136V.738ZM5.692.738H7.538V2.953H5.692V.738ZM2.738,2.215H4.953V3.323a.369.369,0,0,0,.369.369H7.907a.369.369,0,0,0,.369-.369V2.215H16.4V3.323a.369.369,0,0,0,.369.369h2.584a.369.369,0,0,0,.369-.369V2.215h2.215V5.538H2.738Zm0,19.2V6.276h19.2V21.412Z",
    transform: "translate(-2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.968,23H11V33.706H25.029V23H20.968Zm-2.584.738h2.584v2.584H18.384Zm2.584,5.907H18.384V27.061h2.584Zm-5.907-2.584h2.584v2.584H15.061Zm0-3.323h2.584v2.584H15.061Zm-3.323,0h2.584v2.584H11.738Zm0,3.323h2.584v2.584H11.738Zm2.584,5.907H11.738V30.383h2.584Zm3.323,0H15.061V30.383h2.584Zm3.323,0H18.384V30.383h2.584Zm3.323,0H21.706V30.383H24.29Zm0-3.323H21.706V27.061H24.29Zm0-5.907v2.584H21.706V23.738Z",
    transform: "translate(-7.677 -14.509)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.15d35695f3940ed4b657862a9571e64a.svg";
export { ForwardRef as ReactComponent };